const AllExercises = [
   {
      "name":"Posição de prece",
      "tipo":"Manutenção de postura",
      "category":[
         "Alongamento"
      ],
      "url":"/static/photos-exercises/1-posicaoprece.png",
      "reps":2,
      "series":5,
      "descansoAposSerie":1,
      "descansoAposExercicio":30,
      "urlVideo":"https://www.youtube.com/embed/4lXqo3oZNGs",
      "tempoLimite":130,
      "tempoManutencao":5,
      "intensidade":"Intermédio",
      "membros":[
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar em quatro apoios e sentar sobre os calcanhares."
         },
         {
            "ordem":2,
            "instrucao":"Estender os braços para a frente, baixando a cabeça entre os ombros em direção ao chão. Deverá sentir um alongamento nas costas e nos braços."
         }
      ]
   },
   {
      "name":"Ponte de Glúteos",
      "tipo":"Repetições",
      "category":[
         "Reforço Muscular"
      ],
      "url":"/static/photos-exercises/2-ponteGluteos.png",
      "reps":4,
      "series":1,
      "descansoAposSerie":10,
      "descansoAposExercicio":20,
      "urlVideo":"https://www.youtube.com/embed/mK-2Pcz8-mA",
      "tempoLimite":"N.D",
      "tempoManutencao":"N.D",
      "intensidade":"Elementar",
      "membros":[
         "Membros Inferiores",
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Deitar de barriga para cima com os joelhos dobrados e os pés apoiados no chão. "
         },
         {
            "ordem":2,
            "instrucao":"Contrair os glúteos e levantar a pélvis para a posição de ponte, alinhando com o tronco."
         }
      ]
   },
   {
      "name":"Posição gato assanhado",
      "tipo":"Repetições",
      "category":[
         "Alongamento",
         "Ganho de Amplitude Articular"
      ],
      "url":"/static/photos-exercises/3-gatoAssanhado.png",
      "reps":2,
      "series":1,
      "descansoAposSerie":11,
      "descansoAposExercicio":24,
      "urlVideo":"https://www.youtube.com/embed/KL6lQDiI1xo",
      "tempoLimite":"N.D",
      "tempoManutencao":"N.D",
      "intensidade":"Avançado",
      "membros":[
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar na posição de quatro apoios, com as mãos à largura dos ombros e as costas em posição neutra"
         },
         {
            "ordem":2,
            "instrucao":"Com as mãos bem apoiadas no chão, contrair os músculos abdominais e manter a coluna bem alinhada"
         },
         {
            "ordem":3,
            "instrucao":"Inspirar e fletir o tronco, curvando para cima (convexidade para cima), e puxando a barriga para dentro"
         },
         {
            "ordem":4,
            "instrucao":"Ao expirar, arquear o tronco na direção oposta, baixar a barriga em direção ao chão e levantar a cabeça"
         },
         {
            "ordem":5,
            "instrucao":"Descansar alguns segundos e repetir o movimento"
         }
      ]
   },
   {
      "name":"Rotação Lateral",
      "tipo":"Manutenção da postura",
      "category":[
         "Alongamento"
      ],
      "url":"/static/photos-exercises/4-rotacaoLateral.png",
      "reps":4,
      "series":1,
      "descansoAposSerie":50,
      "descansoAposExercicio":30,
      "urlVideo":"https://www.youtube.com/embed/_bIL2oLwixI",
      "tempoLimite":"N.D",
      "tempoManutencao":"N.D",
      "intensidade":"Elementar",
      "membros":[
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Sentado numa cadeira, rodar o tronco e a cabeça, olhando para trás, enquanto cruza a perna contralateral sobre a contrária."
         },
         {
            "ordem":2,
            "instrucao":"Com o antebraço contralateral efetuar pressão sobre a perna cruzada."
         },
         {
            "ordem":3,
            "instrucao":"Regressar à posição inicial e de seguida rodar para o lado contralateral repetindo o mesmo movimento."
         }
      ]
   },
   {
      "name":"Rotações dos MI, em decúbito dorsal",
      "tipo":"Repetições",
      "category":[
         "Alongamento",
         "Ganho de Amplitude Articular"
      ],
      "url":"/static/photos-exercises/rotacaoMI.png",
      "reps":2,
      "series":5,
      "descansoAposSerie":50,
      "descansoAposExercicio":60,
      "urlVideo":"https://www.youtube.com/embed/IiMLB1dZ45g",
      "tempoLimite":"N.D",
      "tempoManutencao":"N.D",
      "intensidade":"Intermédio",
      "membros":[
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Deitar em decúbito dorsal com os joelhos dobrados e os pés bem assentes no chão."
         },
         {
            "ordem":2,
            "instrucao":"Estender os braços para os lados e manter os ombros bem apoiados no chão."
         },
         {
            "ordem":3,
            "instrucao":"Manter os joelhos juntos, deixá-los cair para um lado rodando o tronco. "
         },
         {
            "ordem":4,
            "instrucao":"Voltar à posição inicial e permitir que os joelhos caiam para o lado oposto. "
         }
      ]
   },
   {
      "name":"Alongamento isquiotibiais ",
      "tipo":"Manutenção de posição",
      "category":[
         "Alongamento"
      ],
      "url":"/static/photos-exercises/alongamento_isquiotibiais.png",
      "reps":7,
      "series":44,
      "descansoAposSerie":15,
      "descansoAposExercicio":40,
      "urlVideo":"https://www.youtube.com/embed/iWFZ5NGV5JI",
      "tempoLimite":"N.D",
      "tempoManutencao":"N.D",
      "intensidade":"Intermédio",
      "membros":[
         "Membros Inferiores"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Apoiar o pé numa cadeira colocada em frente ao corpo. "
         },
         {
            "ordem":2,
            "instrucao":"Com ambos os joelhos em extensão tentar chegar à ponta do pé apoiado na cadeira, com as suas mãos."
         },
         {
            "ordem":3,
            "instrucao":"Simultaneamente puxar a ponta do mesmo pé na direção do corpo e sentir o alongamento na zona posterior da perna e coxa. "
         },
         {
            "ordem":4,
            "instrucao":"Aumentar o avanço das mãos, gradualmente, até atingir a ponta do pé (preferencialmente)."
         },
         {
            "ordem":5,
            "instrucao":"Repetir o procedimento com a perna contralateral."
         }
      ]
   },
   {
      "name":"Alongamento glúteo médio",
      "tipo":"Manutenção de Postura",
      "category":[
         "Alongamento"
      ],
      "url":"/static/photos-exercises/alongamento-gluteo-medio.png",
      "reps":8,
      "series":3,
      "descansoAposSerie":14,
      "descansoAposExercicio":23,
      "urlVideo":"https://www.youtube.com/embed/TDPt5s3P3Bs",
      "tempoLimite":"N.D",
      "tempoManutencao":"N.D",
      "intensidade":"Avançado",
      "membros":[
         "Membros Inferiores"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Cruzar uma das pernas sobre a perna contralateral. "
         },
         {
            "ordem":2,
            "instrucao":"Inclinar o tronco sobre as pernas, como que as abraçando. "
         },
         {
            "ordem":3,
            "instrucao":"Pescoço deve acompanhar o movimento do tronco, fletindo durante o movimento."
         }
      ]
   },
   {
      "name":"Deadlift",
      "tipo":"Repetições",
      "category":[
         "Reforço Muscular"
      ],
      "url":"/static/photos-exercises/deadlift.png",
      "reps":2,
      "series":5,
      "descansoAposSerie":19,
      "descansoAposExercicio":26,
      "urlVideo":"https://www.youtube.com/embed/Y4d9BvmOrsY",
      "tempoLimite":222,
      "tempoManutencao":11,
      "intensidade":"Elementar",
      "membros":[
         "Tronco",
         "Membros Inferiores"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar na posição de pé, pés ligeiramente afastados e joelhos “destrancados”. "
         },
         {
            "ordem":2,
            "instrucao":"Mantendo as costas direitas (ombros para trás), descer o tronco na direção do chão, sem aumentar a flexão dos joelhos. "
         },
         {
            "ordem":3,
            "instrucao":"Executar todo o movimento promovendo a flexão das ancas. "
         },
         {
            "ordem":4,
            "instrucao":"Executar o movimento com ou sem carga."
         }
      ]
   },
   {
      "name":"Super-Homem",
      "tipo":"Repetições",
      "category":[
         "Reforço Muscular",
         "Coordenação"
      ],
      "url":"/static/photos-exercises/super-homem.png",
      "reps":2,
      "series":3,
      "descansoAposSerie":30,
      "descansoAposExercicio":40,
      "urlVideo":"https://www.youtube.com/embed/p7a1eneqpts",
      "tempoLimite":33,
      "tempoManutencao":2,
      "intensidade":"Avançado",
      "membros":[
         "Tronco",
         "Membros Superiores",
         "Membros Inferiores"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Começar em posição de apoio, com uma linha reta da cabeça aos pés."
         },
         {
            "ordem":2,
            "instrucao":"Olhar em frente e deixar os pés apoiados no chão e juntos."
         },
         {
            "ordem":3,
            "instrucao":"Manter o corpo imóvel durante todo o movimento, levantar um braço e a perna oposta."
         },
         {
            "ordem":4,
            "instrucao":"Repetir usando o braço e perna opostos."
         },
         {
            "ordem":5,
            "instrucao":"Tentar manter o corpo o mais imóvel possível durante todo o exercício."
         }
      ]
   },
   {
      "name":"Abdominal com joelho e anca a 90º",
      "tipo":"Repetições",
      "category":[
         "Reforço Muscular"
      ],
      "url":"/static/photos-exercises/abdominal.png",
      "reps":30,
      "series":10,
      "descansoAposSerie":30,
      "descansoAposExercicio":100,
      "urlVideo":"https://www.youtube.com/embed/Y4d9BvmOrsY",
      "tempoLimite":222,
      "tempoManutencao":111,
      "intensidade":"Avançado",
      "membros":[
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar na posição de decúbito dorsal com os joelhos dobrados e os braços cruzados sobre o peito."
         },
         {
            "ordem":2,
            "instrucao":"Manter a coluna lombar pressionada em direção ao chão. "
         },
         {
            "ordem":3,
            "instrucao":"Inspirar e depois expirar enquanto eleva os ombros do chão e olha em direção às coxas. "
         },
         {
            "ordem":4,
            "instrucao":"Manter os músculos abdominais contraídos enquanto enrola o tronco superior para cima. "
         },
         {
            "ordem":5,
            "instrucao":"Não permitir que a coluna lombar se descole do chão. "
         },
         {
            "ordem":6,
            "instrucao":"Retornar lentamente para baixo enquanto controla o movimento para chegar à posição inicial."
         }
      ]
   },
   {
      "name":"Elevação de MI em 4 apoios",
      "tipo":"Repetições",
      "category":[
         "Reforço Muscular"
      ],
      "url":"/static/photos-exercises/elevacao_MI_4apoios.png",
      "reps":8,
      "series":3,
      "descansoAposSerie":14,
      "descansoAposExercicio":23,
      "urlVideo":"https://www.youtube.com/embed/TDPt5s3P3Bs",
      "tempoLimite":"N.D",
      "tempoManutencao":"N.D",
      "intensidade":"Elementar",
      "membros":[
         "Membros Inferiores"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Começar na posição de 4 apoios. "
         },
         {
            "ordem":2,
            "instrucao":"Manter as costas retas."
         },
         {
            "ordem":3,
            "instrucao":"Contrair suavemente o assoalho pélvico e os músculos abdominais."
         },
         {
            "ordem":4,
            "instrucao":"Sem mexer a coluna, levantar lentamente uma perna para trás."
         },
         {
            "ordem":5,
            "instrucao":"Retornar à posição inicial e repetir o movimento com a perna contralateral."
         },
         {
            "ordem":6,
            "instrucao":"Manter a coluna imóvel durante todo o movimento."
         }
      ]
   },
   {
      "name":"Ponte com flexão/extensão de joelhos na bola",
      "tipo":"Repetições",
      "category":[
         "Reforço Muscular",
         "Coordenação"
      ],
      "url":"/static/photos-exercises/ponteComFlexao.png",
      "reps":2,
      "series":5,
      "descansoAposSerie":19,
      "descansoAposExercicio":26,
      "urlVideo":"https://www.youtube.com/embed/Y4d9BvmOrsY",
      "tempoLimite":222,
      "tempoManutencao":11,
      "intensidade":"Elementar",
      "membros":[
         "Tronco",
         "Membros Inferiores"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar na posição de decúbito dorsal com os calcanhares sobre a bola suíça."
         },
         {
            "ordem":2,
            "instrucao":"Elevar a pélvis mantendo as pernas esticadas."
         },
         {
            "ordem":3,
            "instrucao":"Manter essa posição, dobrar os joelhos e rolar a bola na sua direção, aplicando uma pressão constante na bola com os calcanhares."
         },
         {
            "ordem":4,
            "instrucao":"Voltar à posição inicial, esticando as pernas, mas mantendo as ancas sempre elevadas."
         }
      ]
   },
   {
      "name":"ADM ativa para flexão do tronco ",
      "tipo":"Repetições",
      "category":[
         "Ganho de amplitude articular",
         "Alongamento"
      ],
      "url":"/static/photos-exercises/ADM_ativa.png",
      "reps":2,
      "series":3,
      "descansoAposSerie":30,
      "descansoAposExercicio":40,
      "urlVideo":"https://www.youtube.com/embed/p7a1eneqpts",
      "tempoLimite":33,
      "tempoManutencao":2,
      "intensidade":"Elementar",
      "membros":[
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar na posição de pé com as pernas em extensão e à largura dos ombros."
         },
         {
            "ordem":2,
            "instrucao":"Deslizar lentamente as mãos pela parte da frente das coxas em direção aos pés."
         },
         {
            "ordem":3,
            "instrucao":"Descer o máximo que conseguir de maneira confortável, mantendo as pernas em extensão."
         },
         {
            "ordem":4,
            "instrucao":"Manter a posição, e depois retornar lentamente para a posição inicial."
         }
      ]
   },
   {
      "name":"Báscula da bacia, sentado na cadeira",
      "tipo":"Repetições",
      "category":[
         "Coordenação",
         "Ganho de Amplitude Articular"
      ],
      "url":"/static/photos-exercises/bascula-bacia.png",
      "reps":2,
      "series":3,
      "descansoAposSerie":30,
      "descansoAposExercicio":40,
      "urlVideo":"https://www.youtube.com/embed/p7a1eneqpts",
      "tempoLimite":33,
      "tempoManutencao":2,
      "intensidade":"Elementar",
      "membros":[
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar sentado numa cadeira com as mãos nas ancas."
         },
         {
            "ordem":2,
            "instrucao":"Enrolar os ombros e a zona cervical para dentro, apoiando o peso sobre o sacro."
         },
         {
            "ordem":3,
            "instrucao":"De seguida, estender a coluna e levar o sacro para trás até sentir o apoio do peso sobre os ísquios abrindo o peito e trazendo os ombros para trás e para baixo. "
         }
      ]
   },
   {
      "name":"Alongamento dinâmico de isquiotibiais",
      "tipo":"Repetições",
      "category":[
         "Alongamento",
         "Ganho de Amplitude Articular"
      ],
      "url":"/static/photos-exercises/Alongamento-Isquiotibiais.png",
      "reps":2,
      "series":3,
      "descansoAposSerie":30,
      "descansoAposExercicio":40,
      "urlVideo":"https://www.youtube.com/embed/p7a1eneqpts",
      "tempoLimite":33,
      "tempoManutencao":2,
      "intensidade":"Elementar",
      "membros":[
         "Membros Inferiores"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar com um joelho no chão e com um pé à frente, abaixo da linha do joelho."
         },
         {
            "ordem":2,
            "instrucao":"Manter o corpo ereto, empurrando as ancas uniformemente para a frente até sentir um alongamento na parte da frente da coxa da perna de trás.  "
         },
         {
            "ordem":3,
            "instrucao":"De seguida, transfira o peso para trás, levando os glúteos em direção ao pé de trás, enquanto estica o joelho da frente e levanta os dedos dos pés. "
         },
         {
            "ordem":4,
            "instrucao":"Deverá sentir um alongamento na parte de trás da coxa da perna da frente.  Continue alternando entre as duas posições."
         }
      ]
   },
   {
      "name":"Abraçar os joelhos em decúbito dorsal ",
      "tipo":"Manutenção de postura",
      "category":[
         "Alongamento",
         "Ganho de Amplitude Articular"
      ],
      "url":"/static/photos-exercises/AbracaoJoelhos.png",
      "reps":2,
      "series":3,
      "descansoAposSerie":30,
      "descansoAposExercicio":40,
      "urlVideo":"https://www.youtube.com/embed/p7a1eneqpts",
      "tempoLimite":33,
      "tempoManutencao":2,
      "intensidade":"Elementar",
      "membros":[
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar na posição de decúbito dorsal. "
         },
         {
            "ordem":2,
            "instrucao":"Levantar um pé e depois o outro."
         },
         {
            "ordem":3,
            "instrucao":"Trazer um joelho em direção ao peito e depois o outro."
         },
         {
            "ordem":4,
            "instrucao":"Usar as mãos para ajudar a abraçar as pernas, enrolando-se como uma bola."
         }
      ]
   },
   {
      "name":"Mountain Climbers",
      "tipo":"Repetições",
      "category":[
         "Resistência",
         "Condicionamento Geral"
      ],
      "url":"/static/photos-exercises/MountainClimbers.png",
      "reps":2,
      "series":3,
      "descansoAposSerie":30,
      "descansoAposExercicio":40,
      "urlVideo":"https://www.youtube.com/embed/p7a1eneqpts",
      "tempoLimite":33,
      "tempoManutencao":2,
      "intensidade":"Elementar",
      "membros":[
         "Membros Inferiores",
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar em posição de prancha, com os cotovelos estendidos e as mãos debaixo dos ombros."
         },
         {
            "ordem":2,
            "instrucao":"Fletir a anca para frente, trazendo o joelho fletido até ao peito e sustentar a posição. "
         },
         {
            "ordem":3,
            "instrucao":"Esticar a perna de volta para trás e repetir o padrão de movimento do outro lado."
         }
      ]
   },
   {
      "name":"Abdominal “Dead bug”",
      "tipo":"Repetições",
      "category":[
         "Reforço Muscular",
         "Coordenação"
      ],
      "url":"/static/photos-exercises/deadBug.png",
      "reps":2,
      "series":3,
      "descansoAposSerie":30,
      "descansoAposExercicio":40,
      "urlVideo":"https://www.youtube.com/embed/p7a1eneqpts",
      "tempoLimite":33,
      "tempoManutencao":2,
      "intensidade":"Elementar",
      "membros":[
         "Tronco",
         "Membros Inferiores"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar na posição de decúbito dorsal."
         },
         {
            "ordem":2,
            "instrucao":"Dobrar os joelhos e apoiar os pés no chão. "
         },
         {
            "ordem":3,
            "instrucao":"Levantar as pernas, uma de cada vez, mantendo os joelhos e as ancas a 90º, e esticar ambos os braços colocando os ombros a 90º.  "
         },
         {
            "ordem":4,
            "instrucao":"Manter a coluna alinhada e acionar os músculos abdominais durante o exercício. "
         },
         {
            "ordem":5,
            "instrucao":"Expirar ao esticar uma perna para a frente o máximo possível e simultaneamente o braço homolateral para trás. "
         },
         {
            "ordem":6,
            "instrucao":"Inspirar ao trazer a perna de volta à posição inicial."
         },
         {
            "ordem":7,
            "instrucao":"Repetir o movimento descrito do outro lado."
         }
      ]
   },
   {
      "name":"Prancha lateral ",
      "tipo":"Manutenção de postura",
      "category":[
         "Reforço Muscular"
      ],
      "url":"/static/photos-exercises/PranchaLateral.png",
      "reps":2,
      "series":3,
      "descansoAposSerie":30,
      "descansoAposExercicio":40,
      "urlVideo":"https://www.youtube.com/embed/p7a1eneqpts",
      "tempoLimite":33,
      "tempoManutencao":2,
      "intensidade":"Elementar",
      "membros":[
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Deitar de lado elevando-se sobre o cotovelo."
         },
         {
            "ordem":2,
            "instrucao":"Manter as pernas esticadas uma sobre a outra."
         },
         {
            "ordem":3,
            "instrucao":"Utilizar o cotovelo e os pés para empurrar e elevar o corpo para longe do chão."
         },
         {
            "ordem":4,
            "instrucao":"Manter uma linha reta da cabeça até os pés."
         },
         {
            "ordem":5,
            "instrucao":"Manter esta posição pelo tempo descrito"
         }
      ]
   },
   {
      "name":"Ponte com contração de adutores",
      "tipo":"Repetições",
      "category":[
         "Reforço Muscular"
      ],
      "url":"/static/photos-exercises/ponteContracaoAdutores.png",
      "reps":2,
      "series":3,
      "descansoAposSerie":30,
      "descansoAposExercicio":40,
      "urlVideo":"https://www.youtube.com/embed/p7a1eneqpts",
      "tempoLimite":33,
      "tempoManutencao":2,
      "intensidade":"Elementar",
      "membros":[
         "Tronco",
         "Membros Inferiores"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar na posição de decúbito dorsal com os joelhos fletidos e os pés bem apoiados no chão."
         },
         {
            "ordem":2,
            "instrucao":"Apertar uma bola entre os joelhos."
         },
         {
            "ordem":3,
            "instrucao":"Manter esta tensão durante todo o exercício, levar a zona pélvica para cima, alinhando com o tronco."
         },
         {
            "ordem":4,
            "instrucao":"Continuar a apertar enquanto baixa as costas para a posição inicial."
         }
      ]
   },
   {
      "name":"Prancha frontal",
      "tipo":"Manutenção de postura",
      "category":[
         "Reforço Muscular"
      ],
      "url":"/static/photos-exercises/pranchaFrontal.png",
      "reps":4,
      "series":1,
      "descansoAposSerie":50,
      "descansoAposExercicio":30,
      "urlVideo":"https://www.youtube.com/embed/_bIL2oLwixI",
      "tempoLimite":"N.D",
      "tempoManutencao":"N.D",
      "intensidade":"Elementar",
      "membros":[
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar na posição de decúbito ventral de barriga e apoiar os dedos dos pés no chão. "
         },
         {
            "ordem":2,
            "instrucao":"Colocar os antebraços no chão e empurrar-se para cima, elevando o tronco e as pernas do chão."
         },
         {
            "ordem":3,
            "instrucao":"Manter o alinhamento do corpo em linha reta, dos ombros até os pés, durante o tempo estabelecido."
         },
         {
            "ordem":4,
            "instrucao":"Estabilizar o tronco e o abdómen, de forma a evitar que as costas descaiam."
         },
         {
            "ordem":5,
            "instrucao":"Manter também a contração dos glúteos e o alinhamento das ancas. Deverá sentir contração nos músculos abdominais."
         }
      ]
   },
   {
      "name":"Círculos da pélvis, em posição de pé",
      "tipo":"Repetições",
      "category":[
         "Ganho de Amplitude Articular",
         "Condicionamento Geral"
      ],
      "url":"/static/photos-exercises/circulosPelvis.png",
      "reps":2,
      "series":5,
      "descansoAposSerie":50,
      "descansoAposExercicio":60,
      "urlVideo":"https://www.youtube.com/embed/IiMLB1dZ45g",
      "tempoLimite":"N.D",
      "tempoManutencao":"N.D",
      "intensidade":"Elementar",
      "membros":[
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar na posição de pé e manter os pés à largura das ancas. "
         },
         {
            "ordem":2,
            "instrucao":"Soltar um pouco os joelhos. "
         },
         {
            "ordem":3,
            "instrucao":"Colocar as mãos sobre as ancas. "
         },
         {
            "ordem":4,
            "instrucao":"Iniciar o movimento fazendo pequenos círculos com a pélvis. "
         },
         {
            "ordem":5,
            "instrucao":"Empurrar as ancas para um lado e depois encaixar o sacro para dentro, trazendo as ancas para a frente."
         },
         {
            "ordem":6,
            "instrucao":"De seguida, empurrar as ancas para o outro lado. "
         },
         {
            "ordem":7,
            "instrucao":"Por fim, empurrar as ancas para trás, levando o sacro para fora."
         },
         {
            "ordem":8,
            "instrucao":"Faça movimentos fluídos, mantendo a parte superior do corpo e a cabeça imóveis. Aos poucos pode aumentar o tamanho do círculo, se for possível. "
         },
         {
            "ordem":9,
            "instrucao":"Repita para o outro sentido."
         }
      ]
   },
   {
      "name":"Extensão da lombar, em decúbito ventral ",
      "tipo":"Manutenção de postura",
      "category":[
         "Reforço Muscular"
      ],
      "url":"/static/photos-exercises/extensaoLombar.png",
      "reps":7,
      "series":44,
      "descansoAposSerie":15,
      "descansoAposExercicio":40,
      "urlVideo":"https://www.youtube.com/embed/iWFZ5NGV5JI",
      "tempoLimite":"N.D",
      "tempoManutencao":"N.D",
      "intensidade":"Elementar",
      "membros":[
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar na posição de decúbito ventral. "
         },
         {
            "ordem":2,
            "instrucao":"Dobrar os cotovelos e pôr as mãos no alinhamento dos ombros."
         },
         {
            "ordem":3,
            "instrucao":"Empurrar a parte superior do seu corpo para cima colocando o tronco em extensão. "
         },
         {
            "ordem":4,
            "instrucao":"Manter as ancas e as coxas sempre no chão."
         },
         {
            "ordem":5,
            "instrucao":"Contrair os glúteos durante todo o movimento."
         },
         {
            "ordem":6,
            "instrucao":"Manter a posição durante o tempo indicado."
         }
      ]
   },
   {
      "name":"Agachamentos",
      "tipo":"Repetições",
      "category":[
         "Reforço Muscular"
      ],
      "url":"/static/photos-exercises/agachamentos.png",
      "reps":2,
      "series":3,
      "descansoAposSerie":30,
      "descansoAposExercicio":40,
      "urlVideo":"https://www.youtube.com/embed/p7a1eneqpts",
      "tempoLimite":33,
      "tempoManutencao":2,
      "intensidade":"Elementar",
      "membros":[
         "Membros Inferiores"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar na posição de pé, mantendo os pés à largura dos ombros."
         },
         {
            "ordem":2,
            "instrucao":"Ativar os músculos abdominais e agachar suavemente. Não permitir que os seus joelhos se desloquem muito para frente. Manter o peso nos calcanhares, não na ponta dos pés. "
         },
         {
            "ordem":3,
            "instrucao":"Contrair os glúteos quando estiver na posição mais baixa e mantenha-os tensos enquanto se levanta para a posição inicial. "
         }
      ]
   },
   {
      "name":"Alongamento dinâmico de isquiotibiais com faixa elástica",
      "tipo":"Repeticoes",
      "category":[
         "Alongamento",
         "Ganho de Amplitude Articular"
      ],
      "url":"/static/photos-exercises/alongamentoDinamico.png",
      "reps":2,
      "series":3,
      "descansoAposSerie":30,
      "descansoAposExercicio":40,
      "urlVideo":"https://www.youtube.com/embed/p7a1eneqpts",
      "tempoLimite":33,
      "tempoManutencao":2,
      "intensidade":"Elementar",
      "membros":[
         "Membros Inferiores"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar na posição de decúbito dorsal e colocar uma cinta ao redor do pé de uma das pernas. "
         },
         {
            "ordem":2,
            "instrucao":"Puxar o joelho em direção ao peito e depois esticar a perna em direção ao teto até sentir um alongamento na região posterior da coxa. "
         },
         {
            "ordem":3,
            "instrucao":"Repetir o movimento com a perna contralateral."
         }
      ]
   },
   {
      "name":"Flexão lateral do tronco, em posição de pé",
      "tipo":"Repetições",
      "category":[
         "Reforço Muscular",
         "Ganho de Amplitude Articular",
         "Alongamento"
      ],
      "url":"/static/photos-exercises/flexaoLateral.png",
      "reps":2,
      "series":3,
      "descansoAposSerie":30,
      "descansoAposExercicio":40,
      "urlVideo":"https://www.youtube.com/embed/p7a1eneqpts",
      "tempoLimite":33,
      "tempoManutencao":2,
      "intensidade":"Elementar",
      "membros":[
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar na posição de pé com os pés à largura dos ombros."
         },
         {
            "ordem":2,
            "instrucao":"Manter a coluna reta e olhar para a frente. Inclinar o tronco para um lado."
         },
         {
            "ordem":3,
            "instrucao":"Deslizar a mão ao lado da coxa e não fazer flexão do tronco. "
         },
         {
            "ordem":4,
            "instrucao":"Depois de inclinar o máximo que conseguir, retornar lentamente para a posição inicial, controlando o movimento"
         }
      ]
   },
   {
      "name":"Flexão do tronco, na posição sentada ",
      "tipo":"Manutenção de Posturas",
      "category":[
         "Alongamento",
         "Ganho de Amplitude Articular"
      ],
      "url":"/static/photos-exercises/FlexaoTronco.png",
      "reps":2,
      "series":3,
      "descansoAposSerie":30,
      "descansoAposExercicio":40,
      "urlVideo":"https://www.youtube.com/embed/p7a1eneqpts",
      "tempoLimite":33,
      "tempoManutencao":2,
      "intensidade":"Elementar",
      "membros":[
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Sentar alinhado numa cadeira e com os joelhos fletidos. "
         },
         {
            "ordem":2,
            "instrucao":"Fletir o tronco baixando a cabeça em direção aos joelhos. "
         },
         {
            "ordem":3,
            "instrucao":"Retornar à posição inicial e repetir."
         }
      ]
   },
   {
      "name":"Ponte com apoio em uma perna",
      "tipo":"Repetições",
      "category":[
         "Reforço Muscular",
         "Coordenação"
      ],
      "url":"/static/photos-exercises/ponteApoio.png",
      "reps":2,
      "series":3,
      "descansoAposSerie":30,
      "descansoAposExercicio":40,
      "urlVideo":"https://www.youtube.com/embed/p7a1eneqpts",
      "tempoLimite":33,
      "tempoManutencao":2,
      "intensidade":"Elementar",
      "membros":[
         "Membros Inferiores",
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar em decúbito dorsal com as pernas afastadas à largura das ancas."
         },
         {
            "ordem":2,
            "instrucao":"Dobrar uma das pernas mantendo o pé apoiado no chão. "
         },
         {
            "ordem":3,
            "instrucao":"O joelho e o pé devem ficar alinhados com a anca homolateral. "
         },
         {
            "ordem":4,
            "instrucao":"Contrair os músculos abdominais e glúteos e elevar a zona pélvica, levantando a perna esticada. "
         },
         {
            "ordem":5,
            "instrucao":"Retornar à posição inicial e repetir o movimento."
         }
      ]
   },
   {
      "name":"Báscula da bacia em decúbito dorsal",
      "tipo":"Repetições",
      "category":[
         "Coordenação",
         "Ganho de Amplitude Articular"
      ],
      "url":"/static/photos-exercises/bascula.png",
      "reps":2,
      "series":3,
      "descansoAposSerie":30,
      "descansoAposExercicio":40,
      "urlVideo":"https://www.youtube.com/embed/p7a1eneqpts",
      "tempoLimite":33,
      "tempoManutencao":2,
      "intensidade":"Elementar",
      "membros":[
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Iniciar o movimento em decúbito dorsal com os joelhos fletidos e os pés bem apoiados no chão. "
         },
         {
            "ordem":2,
            "instrucao":"Puxar o umbigo em direção à coluna vertebral e contrair os glúteos para fazer o osso do sacro rolar, elevando-o do chão."
         },
         {
            "ordem":3,
            "instrucao":"A maior parte do esforço deve vir dos músculos abdominais e glúteos."
         },
         {
            "ordem":4,
            "instrucao":"A parte inferior das costas deve ser pressionada firmemente contra o chão."
         }
      ]
   },
   {
      "name":"Abdução da anca em posição lateral – ostra",
      "tipo":"repetições",
      "category":[
         "Reforço Muscular",
         "Ganho de Amplitude Articular"
      ],
      "url":"/static/photos-exercises/ostra.png",
      "reps":2,
      "series":3,
      "descansoAposSerie":30,
      "descansoAposExercicio":40,
      "urlVideo":"https://www.youtube.com/embed/p7a1eneqpts",
      "tempoLimite":33,
      "tempoManutencao":2,
      "intensidade":"Elementar",
      "membros":[
         "Tronco"
      ],
      "instrucoes":[
         {
            "ordem":1,
            "instrucao":"Deitar de lado com os pés, tornozelos e joelhos unidos. "
         },
         {
            "ordem":2,
            "instrucao":"Fletir um pouco os joelhos e contrair os músculos do tronco. "
         },
         {
            "ordem":3,
            "instrucao":"Mantendo os pés juntos, levantar o joelho de cima. "
         },
         {
            "ordem":4,
            "instrucao":"Evitar rodar o corpo para trás durante o movimento. "
         },
         {
            "ordem":5,
            "instrucao":"Retornar à posição inicial e repetir."
         }
      ]
   }
];

export default AllExercises;